import React from 'react';
import PropTypes from 'prop-types';

import CaregiverViewScene from './CaregiverViewScene';

import backend from 'utils/backend';

const loadCaregiverProfile = (caregiverRn) => {
  return backend.caregiver.getCaregiver(caregiverRn, true, true, true, true, true, true);
};

const loadScheduleByMonth = (caregiverRn, byMonths, loadCaregiverUpdates, options) => {
  return backend.caregiver.schedule.loadByMonth(caregiverRn, byMonths, loadCaregiverUpdates, options);
};

const CaregiverView = (props) => {
  return (
    <CaregiverViewScene
      {...props}
      loadCaregiverProfile={loadCaregiverProfile}
      loadScheduleByMonth={loadScheduleByMonth}
      showAgreements={true}
    />
  );
};

CaregiverView.propTypes = {
  caregiverRn: PropTypes.string.isRequired,
  statusProgressWrap: PropTypes.func.isRequired,
};

export default React.memo(CaregiverView);
